export default "/images/c7988e563157b9d14b710cd31ba51d63.avif";